import React, {  } from 'react';


export const Icon = ({icon, style}:{icon: string, style?: {}}) => {
    return <span className={icon} style={style}/>
}
export default Icon;